module.exports = __webpack_public_path__ + "static/media/charger-pin-high-power.60416d49.png";